<template>
    <transition name="fade" mode="out-in" :duration="{ enter: 700, leave: 100 }">    
        <div class="product-single-container page-container">
            <button @click.stop="$router.go(-1)" class="back-to-outfit">
                <div class="wtw-container">
                    <span class="stay-black">Back</span>
                </div>
            </button>
            <slide-show-zoom
                ref="zoom" 
                v-show="showZoomModal"
                :images="zoomImages"
                :product="true"
                :index="zoomIndex"
                @close-modal="showZoomModal = false"
            />
            <product-single 
                :currentProduct="currentProduct"
                :outfit="currentOutfit"
                :slideShowImages="slideShowImages"
                :imageClicked="openImageZoom"
                :imageChanged="() => {}"
                :outfitImageClicked="productId => changeCurrentProduct(currentOutfit, productId)"
                :productChanged="product => changeProduct(currentOutfit, product)"
                :hideCard="false"
                v-if="currentProduct && dataLoaded && !cartLoading && !shareLoading"
                @change-product="productChanged"
                key="1"
            />
            <div v-else key="2">
                <loader></loader>
            </div>
        </div>
    </transition>
</template>

<script>
    import { mapGetters } from 'vuex';
    import ProductSingle from './product-single.vue';
    import Loader from '../common/loader.vue';
    import SlideShowZoom from '../common/slideshow-zoom.vue';

    export default {
        components: { ProductSingle, Loader, SlideShowZoom },
        data() {
            return {
                dataLoaded: false,
                showZoomModal: false,
                zoomIndex: 0
            };
        },
        computed: {
            slideShowImages() {
                if(this.currentProduct?.product_images) {
                    const colorImages = this.currentProduct.product_images;
                    return colorImages.map(image => {
                        return {
                            uri: image.product_image_uri,
                            zoomUri: image.product_image_zoom_uri,
                            alt: `${image.product_title}_${image.product_image_id}`,
                            key: image.product_image_id,
                        };
                    });
                }
                
                return [];
            },
            zoomImages() {
                return this.slideShowImages.map(image => image.zoomUri);
            },
            currentProduct() {
                let product;
                if(this.currentOutfit.currentProductIndex >= 0) {
                    product = this.currentOutfit.products[this.currentOutfit.currentProductIndex];
                    return this.filterImages(product, product.product_option_value_id);
                }
                product = this.currentProductFromState;
                const { productOptionValueId } = this.$route.query;
                return this.filterImages(product, productOptionValueId);
            },
            ...mapGetters({
                currentProductFromState: 'products/getCurrentProduct',
                currentOutfit: 'outfits/currentOutfit',
                returnPage: "menu/returnPage",
                shareLoading: 'share/getLoadingStatus',
                cartLoading: 'cart/getLoadingStatus',
            })
        },
        methods: {
            fetchProduct(id, productOptionValueId = null, outfitId = null) {
                return this.$store
                    .dispatch({
                        type: 'products/fetchProduct',
                        id,
                        outfitId,
                        productOptionValueId
                    });
            },
            changeCurrentProduct(outfit, productId) {
                if(!outfit.products) return;

                const currentProductIndex = outfit.products.findIndex(product => product.product_id === productId);
                this.$store.dispatch('outfits/changeCurrentProduct', {
                    currentProductIndex,
                    currentOutfit: outfit,
                });
            },
            changeProduct(outfit, product) {
                if(!!outfit.products) {
                    this.$store.dispatch('outfits/changeOutfitProduct', {
                        product,
                        index: outfit.currentProductIndex, 
                        currentOutfit: outfit,
                    });

                    this.changeCurrentProduct(outfit, product.product_id);
                } else {
                    this.$store.dispatch('products/changeCurrentProduct', {
                        product,
                        index: outfit.currentProductIndex, 
                        outfitId: outfit.outfit_id,
                    });
                }
            },
            openImageZoom(index) {
                this.showZoomModal = true;
                this.zoomIndex = index;
                this.$refs.zoom.opened();
            },
            productChanged(newProduct) {
                this.$helpers.visitProduct(
                    this.$router,
                    newProduct,
                    {
                        productOptionValueId: newProduct.product_option_value_id,
                        productOptionSizeValueId: newProduct.product_option_value_id_size,
                        replaceRoute: true,
                    }
                );
            },
            filterImages(product, productOptionValueId) {
                if (!productOptionValueId || !product.product_images) return product;
                const images = product.product_images.filter(image => image.product_option_value_id === productOptionValueId);
                return { ...product, product_images: images };
            }
        },
        created(){
            const { id } = this.$route.params;
            if(id){
                const { productOptionValueId, outfitId, outfitType } = this.$route.query;
                const productPromise = this.fetchProduct(id, productOptionValueId, outfitId);
                let outfitPromise;
                
                if(outfitId && (!this.currentOutfit || this.currentOutfit.outfit_id !== outfitId || !this.currentOutfit.isDetailed)) {
                    this.dataLoaded = false;
                    outfitPromise = this.$store.dispatch('outfits/fetchOutfit', {
                        outfitId,
                        outfitType,
                    });
                } else if(!outfitId) {
                    this.$store.commit('outfits/resetCurrentOutfit');
                }

                Promise.all([productPromise, outfitPromise])
                    .then(() => {
                        this.changeCurrentProduct(this.currentOutfit, id);
                        this.dataLoaded = true;
                    });
            }
        },
        mounted() {
            this.$store.commit({
                type: 'footer/hideFooter'
            });
        },
        watch: {
            showZoomModal(value) {
                if(value) {
                    this.$helpers.removeScrollingBehavior();
                } else {
                    this.$helpers.addScrollingBehavior(this.$router.currentRoute.path);
                }
            },
        }
    };
</script>

<style lang="scss" scoped>
    .product-single-container {
        width: 100vw;
        display: flex;
        flex-flow: column;

        .product-wrapper {
            padding: 0 13px;
        }
    }
</style>